// src/components/noticias/NoticiaDestacada.js
import React from 'react';
import { Link } from 'react-router-dom';
import ImageCarousel from './ImageCarousel';

function NoticiaDestacada({ noticia }) {
  if (!noticia) return null;
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 bg-brand-dark/50 p-4 rounded-xl max-w-4xl mx-auto">
      <ImageCarousel images={noticia.images} />
      <div className="flex flex-col justify-between">
        <div>
          <span className="inline-block px-4 py-1 mb-2 text-sm font-medium text-brand-peach bg-brand-red/20 rounded-full">
            {noticia.type}
          </span>
          <h2 className="text-3xl font-morganite text-brand-white mb-3">
            {noticia.title}
          </h2>
          <p className="text-sm text-brand-white/70 mb-4 line-clamp-5">
            {noticia.body}
          </p>
        </div>
        <Link
          to={`/noticias/${noticia.slug}`}
          className="inline-block px-6 py-2 bg-brand-red text-brand-white rounded-lg 
                   font-medium hover:bg-brand-red/90 transition-all duration-200 w-fit"
        >
          Ver más
        </Link>
      </div>
    </div>
  );
}

export default NoticiaDestacada;